function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeDasharray: "1 1",
  d: "M0 3.501h21"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.472 5a4.5 4.5 0 01-8.971-.5 4.58 4.58 0 01.028-.5h-.064a3.5 3.5 0 00-6.928 0h-.036v1h-.972a4.593 4.593 0 01-.028-.5 4.5 4.5 0 018.972-.5h.028v1h.036a3.5 3.5 0 006.928 0h1.006z"
});
function SvgSmooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 9.001,
    viewBox: "0 0 21 9.001"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='9.001' viewBox='0 0 21 9.001'%3e %3cg%3e %3cpath fill='none' stroke='%23fff' stroke-dasharray='1 1' d='M0 0L0 21' transform='rotate(-90 4.5 4.5) translate(5.499)'/%3e %3cpath fill='%23fff' d='M4 16.971A4.5 4.5 0 0 1 4.5 8a4.58 4.58 0 0 1 .5.028v-.064a3.5 3.5 0 0 0 0-6.928V1H4V.028A4.593 4.593 0 0 1 4.5 0 4.5 4.5 0 0 1 5 8.972V9H4v.036a3.5 3.5 0 0 0 0 6.928v1.006z' transform='rotate(-90 4.5 4.5) translate(0 2.501)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgSmooth as ReactComponent };